import { z } from 'zod';

export const WorkspaceVersionDto = z.object({
    workspaceId: z.string(),
    updatedAt: z.string(),
    version: z.number(),
});

export type WorkspaceVersionDto = z.infer<typeof WorkspaceVersionDto>;

export const shapes = {
    WorkspaceVersionDto,
};